
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { ConfirmDialog, Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, ConsusService, IMember, IProfileWebsite, ITeam, ITeamWebsite, IUploadedFile, MemberService, SanitizedResponse, TeamService } from "../../../../../services";
import { Button, Checkbox, ComposedPassword, DOMHelper, Dropdown, Form, FormControl, NoseurObject, ObjectHelper, TabPane, TabPanel, TextAreaInput, TextInput } from "@rivtn/noseur";
import ImportExport from "../../../../page_design/ImportExport";
import MediaInput, { MediaInputManageRef } from "../../../../shared/MediaInput";

export interface BannerMediasProps {
    team: ITeam;
    profile: IMember;
    teamWebsite: ITeamWebsite;
}

function BannerMedias(props: BannerMediasProps) {

    const { team } = props;
    const teamService = TeamService.getInstance();
    const consusService = ConsusService.getInstance();
    const [profile, _] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.teams.settings.general.banner_medias;

    return (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div style={{ display: "flex" }}>
                <span>{labels.banner_1}</span>
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.make_primary} style={{ marginLeft: 15 }} defaultChecked={props.teamWebsite.extra_data?.primary_banner_index === 0} onChecked={(v) => makePrimary(v ? 0 : null)} />
            </div>
            <MediaInput instruction={i18nManager.Labels.common.click_to_choose} style={{ alignSelf: "center", marginTop: 10 }} width="100%" height={240}
                default={props.teamWebsite.media["BANNER"]?.[0]} onSelectFiles={(files) => {
                    uploadBanner(0, files[0]);
                }} onGenerateWithAi={async () => {
                    return new File(["We are here"], "we.txt", { type: 'text/plain' });
                }} onRemove={async () => {
                    updateBannersIndex(0, "").catch(BaseService.reportError);
                }} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", marginTop: 15 }}>
            <div style={{ display: "flex" }}>
                <span>{labels.banner_2}</span>
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.make_primary} style={{ marginLeft: 15 }} defaultChecked={props.teamWebsite.extra_data?.primary_banner_index === 1} onChecked={(v) => makePrimary(v ? 1 : null)} />
            </div>
            <MediaInput instruction={i18nManager.Labels.common.click_to_choose} style={{ alignSelf: "center", marginTop: 10 }} width="100%" height={240}
                default={props.teamWebsite.media["BANNER"]?.[1]} onSelectFiles={(files) => {
                    uploadBanner(1, files[0]);
                }} onGenerateWithAi={async () => {
                    return new File(["We are here"], "we.txt", { type: 'text/plain' });
                }} onRemove={async () => {
                    updateBannersIndex(1, "").catch(BaseService.reportError);
                }} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", marginTop: 15 }}>
            <div style={{ display: "flex" }}>
                <span>{labels.banner_3}</span>
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.make_primary} style={{ marginLeft: 15 }} defaultChecked={props.teamWebsite.extra_data?.primary_banner_index === 2} onChecked={(v) => makePrimary(v ? 2 : null)} />
            </div>
            <MediaInput instruction={i18nManager.Labels.common.click_to_choose} style={{ alignSelf: "center", marginTop: 10 }} width="100%" height={240}
                default={props.teamWebsite.media["BANNER"]?.[2]} onSelectFiles={(files) => {
                    uploadBanner(2, files[0]);
                }} onGenerateWithAi={async () => {
                    return new File(["We are here"], "we.txt", { type: 'text/plain' });
                }} onRemove={async () => {
                    updateBannersIndex(2, "").catch(BaseService.reportError);
                }} />
        </div>
    </div>);

    async function updateBannersIndex(index: number, url: string) {
        if (!("BANNER" in props.teamWebsite?.media)) {
            (props.teamWebsite?.media as any)["BANNER"] = [];
        }
        if ((props.teamWebsite?.media)?.["BANNER"].length < index) {
            for (let count = 0; count < index; count++) {
                if (!(props.teamWebsite.media)["BANNER"][count]) {
                    (props.teamWebsite.media)["BANNER"][count] = "";
                }
            }
        }
        (((props.teamWebsite?.media)?.["BANNER"] ?? []) as string[])[index] = url;
        await teamService.updateTeamWebsite(team.external_id, { ...props.teamWebsite, media: (props.teamWebsite?.media ?? {}) }).then(({ sanitized }: SanitizedResponse<ITeamWebsite>) => {
            Siren.alert(labels.update_success);
        });
    }

    function uploadBanner(index: number, file: File) {
        ConfirmDialog({
            onLoading: async (alert) => {
                consusService.uploadFile(`/omnehost/team/media/BANNER`, `${team.external_id}_${index}${ObjectHelper.getExtension(file.name, { lastOnly: true, })}`, file).then(async ({ sanitized }: SanitizedResponse<IUploadedFile>) => {
                    await updateBannersIndex(index, sanitized.consus_download_url);
                }).catch(BaseService.reportError).finally(() => {
                    alert.hide();
                });
                return false;
            }
        }).show();
    }

    function makePrimary(index: number | null) {
        if (!props.teamWebsite.extra_data) props.teamWebsite.extra_data = {};
        props.teamWebsite.extra_data.primary_banner_index = index;
        teamService.updateTeamWebsite(team.external_id, { ...props.teamWebsite }).then(({ sanitized }: SanitizedResponse<ITeamWebsite>) => {
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError);
    }

}

export default BannerMedias;
